import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { WarningRounded } from '../../../Components/Atoms/Icons';
import { AuthContext, invitationLoadedFor } from '../../../Contexts/AuthContext';
import Typography from '../../../Components/Atoms/Typography';
import LoadingScreen from '../../../Components/Atoms/LoadingScreen';
import InvitationLayout from '../../Components/InvitationLayout';
import { PROBLEM_TEXT } from '../../../utils/requestStatus';

import './styles.scss';

// Reached for an unknown or removed invitation link; the next step lies with
// the restaurant, which can share its current link.
const ErrorPage = () => {
  const { invitationId = '' } = useParams();
  const { invitation, init } = useContext(AuthContext);
  const navigate = useNavigate();
  const valid = invitationLoadedFor(invitation, invitationId) && !invitation.invalid;

  useEffect(() => {
    if (invitation.id !== invitationId) init(invitationId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invitationId]);

  // An earlier load may have failed only temporarily: a valid link goes back to joining.
  useEffect(() => {
    if (valid) navigate(`/${invitationId}`, { replace: true });
  }, [valid, invitationId, navigate]);

  if (!invitationLoadedFor(invitation, invitationId) || valid) return <LoadingScreen loading />;

  return (
    <InvitationLayout>
      <div id='error-page-screen' role='alert'>
        <WarningRounded className='warning' />
        <Typography variant='h3' className='invitation-title' translation='helpersAndErrors'>
          Invitation link not valid
        </Typography>
        <Typography variant='text-2' color='subdued' translation='helpersAndErrors'>
          {PROBLEM_TEXT['invalid-link']}
        </Typography>
      </div>
    </InvitationLayout>
  );
};

export default ErrorPage;
